// removed by extract-text-webpack-plugin
module.exports = {"overlay":"style__overlay___1AvHG","overlayModal":"style__overlayModal___2sCf4","overlayModalInner":"style__overlayModalInner___12Ox5","overlayCloseButton":"style__overlayCloseButton___2SUoY","overlayModalTitle":"style__overlayModalTitle___3dU9v","overlayModalText":"style__overlayModalText___2vn7H","overlayModalTextBold":"style__overlayModalTextBold___3ObYk","overlayModalButtons":"style__overlayModalButtons___GLXUs","overlayModalButtonsItem":"style__overlayModalButtonsItem___wHiCO","overlayModalButtonsItemButton":"style__overlayModalButtonsItemButton___1hJWp","buttonActive":"style__buttonActive___2Ilad"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modal-cropp/style.css
// module id = 385
// module chunks = 0